import type { LucideIcon } from 'lucide-react';
import { Euro, FolderTree, Gift, Layers, ListChecks, Percent, Tag, Truck } from 'lucide-react';
import type { ActionType } from '~/lib/schemas/actions';

export interface ActionTypeMeta {
	type: ActionType;
	labelKey: string;
	icon: LucideIcon;
}

/** Canonical 8 action types with their i18n label key + icon (per 06-editor-spec.md). */
export const ACTION_TYPE_META: ActionTypeMeta[] = [
	{ type: 'percentage-discount', labelKey: 'promotion.action.types.percentageDiscount', icon: Percent },
	{ type: 'value-discount', labelKey: 'promotion.action.types.valueDiscount', icon: Euro },
	{ type: 'fixed-price', labelKey: 'promotion.action.types.fixedPrice', icon: Tag },
	{ type: 'bogo', labelKey: 'promotion.action.types.bogo', icon: Layers },
	{ type: 'gift-product', labelKey: 'promotion.action.types.giftProduct', icon: Gift },
	{ type: 'per-product-discount', labelKey: 'promotion.action.types.perProductDiscount', icon: ListChecks },
	{ type: 'category-discount', labelKey: 'promotion.action.types.categoryDiscount', icon: FolderTree },
	{ type: 'shipping-discount', labelKey: 'promotion.action.types.shippingDiscount', icon: Truck }
];

export const ACTION_TYPE_META_MAP = Object.fromEntries(ACTION_TYPE_META.map(m => [m.type, m])) as Record<ActionType, ActionTypeMeta>;

/**
 * Form `type` (kebab) ↔ backend `CartActionToken.ActionType` (PascalCase wire value).
 * Reconciled against Core/server/Libraries/BizWeb.NC.Base/CartActions/* (see
 * task-analysis/admin-redesign-phase4 "Action Payload reconciliation").
 */
export const ACTION_TYPE_TO_WIRE: Record<ActionType, string> = {
	'percentage-discount': 'PercentageDiscount',
	'value-discount': 'AmountDiscount',
	'fixed-price': 'FixedPriceDiscount',
	'bogo': 'BogoDiscount',
	'gift-product': 'AddFreeProduct',
	'per-product-discount': 'ProductDiscount',
	'category-discount': 'CategoryDiscount',
	'shipping-discount': 'ShippingFeeDiscount'
};

export const WIRE_TO_ACTION_TYPE: Record<string, ActionType> = Object.fromEntries(
	Object.entries(ACTION_TYPE_TO_WIRE).map(([k, v]) => [v, k as ActionType])
);
